import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import config from '../../../config';
import { getLatLonFromPath } from '../../../utils/urls/getLatLonFromPath';
import legacyUserSettingsPropType from '../../../propTypes/legacyUserSettings';
import canUseDOM from '../../../common/canUseDom';
import {
  navigatedToPage,
} from '../../../actions/segmentEvents';

class PageError extends Component {
  static propTypes = {
    doNavigatedToPage: PropTypes.func.isRequired,
    legacyUserSettings: legacyUserSettingsPropType.isRequired,
  };
  componentDidMount() {
    const {
      doNavigatedToPage,
      legacyUserSettings,
    } = this.props;
    if (canUseDOM) {
      const coordinates = getLatLonFromPath(window.location.href);
      const forecastPageTitle = `${coordinates[0]} / ${coordinates[1]}`;
      doNavigatedToPage('Forecast Outage', {
        userType: legacyUserSettings.type,
        forecastLocation: coordinates,
        // path: window.location.href,
        title: forecastPageTitle,
        // referrer
        // search:
        // url:
      });
    }
  }

  render() {
    const mailto = `mailto:${config.pages.error.support_email}`;
    return (
      <article className="error-message page-error">
        <h1>Forecast Page Outage</h1>
        <section>
          <p>Buoyweather’s forecast data is currently experiencing an outage.
            Please check back regularly as we work to solve the problem.</p>

          <p>Contact us at
          <a href={mailto}> {config.pages.error.support_email}</a> for immediate
          assistance.</p>

        </section>
      </article>
    );
  }
}

export default connect(
  () => ({}),
  dispatch => ({
    doNavigatedToPage: (name, properties) =>
      dispatch(navigatedToPage(name, properties)),
  }),
)(PageError);



// WEBPACK FOOTER //
// ./src/components/Errors/PageError/PageError.js